import React, { useState } from 'react'
import moment from 'moment'
import BotMessage from '../chatSection/BotMessage'
import { BOT_USER_ID, BOT_USER_NAME } from '../../../../utils/constant.js'
import { deduplicateDocuments } from '../../../../utils'
import BOT_LOGO from '../../../../asserts/icon/icon-logo.svg'

export const ThreadsItem = ({ msg, item, receipt, onClickItem, isPinnedMessagesSection, documents, explanation }) => {
    const [unread, setUnread] = useState(null)

    useState(() => {
        const newUnread = receipt.tunread ? receipt.tunread.includes(msg._id) : null
        setUnread(newUnread)
    }, [receipt])

    const deduplicatedDocuments = deduplicateDocuments(documents)
    const isBotMessage = msg.u.username === BOT_USER_ID
    const displayName = isBotMessage ? 'Apeiron AI' : item.sender_person

    return (
        <React.Fragment key={msg._id || msg.ts}>
            <div className='message border-b cursor-pointer' onClick={() => onClickItem(msg)}>
                <div className='message-avatar'>
                    {isBotMessage ? <img src={BOT_LOGO} alt={'profile'} /> : item.img ? (
                        <img src={item.img} alt={'profile'} />
                    ) : (
                        <img
                            src={`data:image/svg+xml;utf8,
                                <svg xmlns='http://www.w3.org/2000/svg' width='64' height='64'>
                                    <text x='50%' y='50%' font-size='48' text-anchor='middle' dominant-baseline='middle' font-family='Gilroy'>
                                        ${item.sender_person ? item.sender_person.charAt(0) : ''}
                                    </text>
                                </svg>`}
                            alt={'profile'}
                        />
                    )}
                </div>
                <div className='message-text'>
                    <div>
                        <span className='message-user-name'>{displayName}</span>
                        <span className='message-date'>
                            {moment(item.created_at).format('MMM DD, YYYY')} at{' '}
                            {moment(item.created_at).format('h:mm A')}
                        </span>
                    </div>
                    {deduplicatedDocuments.length > 0 ? (
                        <BotMessage documents={deduplicatedDocuments} explanation={explanation}/>
                    ) : (
                        <div dangerouslySetInnerHTML={{ __html: item.text }} />
                    )}
                    {!isPinnedMessagesSection && (
                        <div className='flex-between'>
                            <span>replies {msg.tcount}</span>
                            {unread && <span className="blue-dot"></span>}
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    )
}
